import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

type Params = uui.domain.actions.rpc.simulation.ImportAllOrdersFromSimulationAction['params']

/**
 * Export Simulation data into Operations of the Active Territory.
 *
 * @private
 */
export const importAllOrdersFromSimulation = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  Params,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/simulation/importAllOrdersFromSimulation', async (params, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/simulation/importAllOrdersFromSimulation', {
      category: 'rpc',
      type: 'rpc/simulation/importAllOrdersFromSimulation',
      params,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      'Unknown error on {importAllOrdersFromSimulation}',
      { tags: ['rpc', 'simulation'] },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: 'Deleting Simulations Failed',
      error,
    })
  }
})
